module.exports = __webpack_public_path__ + "static/media/pic6.f492c2c6.png";